import React from 'react';
import {connect} from 'react-redux';
import ReactEmailCapture from '@homeaway/react-email-capture';

import './styles.less';

export function mapStateToProps({modules: {emailCapture = {}}, config}) {
    return {
        ...emailCapture,
        routePath: `${emailCapture.routePath}?site=${config.site.name}`,
        brandName: config.site.humanReadableName,
    };
}

export function EmailCaptureComponent(props) {
    return (
        <section
            className={`EmailCaptureSection section ${
                props.display === false ? 'collapse' : ''
            }`}
        >
            <ReactEmailCapture {...props} displayMode="inline" />
        </section>
    );
}

export const EmailCapture = connect(mapStateToProps)(EmailCaptureComponent);

EmailCapture.displayName = 'EmailCapture';

export default EmailCapture;
